import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "@/store/redux/store";
import SwitchersMapMod from "../SwitchersPanel/SwitchersMapMod";
import InputSelectCity from "./compnents/InputSelectCity";
import { OptionType } from "../InputForms/SelectInputMap/SelectInputMap";
import useCity from "../../hooks/useCity";
import { ICity } from "@/shared/types/city";
import { IBusStation } from "@/shared/types/busStaition";
import InputSelectBusStop from "./FormBusstopsSearch/InputsBusStops/InputSelectBusStop";
import InputSelectRoadmap from "./FormRoadmapsSearch/InputsRoadmaps/components/InputSelectRoadmap";
import { IParameter } from "@/api/types";
import useBusstaitions from "../../hooks/useBusstaitions";
import useRoadmaps from "../../hooks/useRoadmaps";
import { IRoadmapWithPoints, setDate, setRoadmap, setRoadmaps, setRouteDirection } from "../../store/mapScreenSlce";
import styled from "styled-components";
import DatePicker from "../../../../shared/components/Inputs/DatePicker";
import { IStopPointShipping } from "@/api/busStaitions/types";
import { TMapLoadings } from "../../types/types";
import SwitcherTransport from "../SwitcherTransport/SwitcherTransport";

import imgTramRowUp from '../../../../assets/images/arrow-fill-red.svg';
import imgTramArrowDown from '../../../../assets/images/arrow-fill-2-red.svg';
import imgBusRowUp from '../../../../assets/images/arrow-fill-up.svg';
import imgBusArrowDown from '../../../../assets/images/arrow-fill-2.svg';
import { IRoadmap } from "@/shared/types/roadmap";
import { useFormResetSync } from "../../hooks/useFormResetSync";

const SelectForm = () => {
    const dispatch = useDispatch();
    const mode = useSelector((state: RootState) => state.mapScreen.mapMode);
    const {
        cities,
        citiesTo,
        loadings,
        busStations,
        busStationsTo,
        busStationsForm,
        busStationsShippingFrom, busStationsShippingTo,
        formRoadmaps,
        cityRoadmaps,
        roadmaps,
        routeDirection
    } = useSelector((state: RootState) => state.mapScreen);
    const [citiesInputOptions, setCitiesInputOptions] = useState<OptionType[]>();
    const [citiesToInputOptions, setCitiesToInputOptions] = useState<OptionType[]>();
    const {
        isLoadingCities,
        selectCity,
        selectCityTo,
    } = useCity();
    const { selectBusStaition, selectBusStaitionTo } = useBusstaitions();
    const [roadmapsInputOptions, setRoadmapsInputOptions] = useState<OptionType[]>();
    const [busStationsInputOptions, setBusStationsInputOptions] = useState<OptionType[]>(); // опции остановок с которых можно уехать 
    const [busStationsToInputOptions, setBusStationsToInputOptions] = useState<OptionType[]>();
    const { selectRoadmapByForm } = useRoadmaps();

    const loadingsOptions: Record<string, TMapLoadings[]> = {
        city: ['cities'],
        cityTo: ['citiesTo', 'roadMaps'],
        busStaitions: ['cities', 'busStaitions', 'fetchBusStationShippingFrom'],
        busStaitionsTo: ['busStaitionsTo', 'fetchBusStationShippingTo'],
    }

    function includesLoadingOption(key: string, arr: string[]): boolean {
        const options = loadingsOptions[key];
        if (!options) return false;

        return options.some(option => arr.includes(option));
    }

    function fillCitiesOptions(cities: ICity[]) {
        const options = adapterOptions(cities);
        setCitiesInputOptions(options);
    }

    function fillCitiesToOptions(cities: ICity[]) {
        const options = adapterOptions(cities);
        setCitiesToInputOptions(options);
    }

    function adapterOptions(array: ICity[] | IBusStation[] | any): OptionType[] {
        return array.map((el) => ({
            label: el?.name ?? '',
            value: el?.id.toString() ?? '',
        }));
    }

    useEffect(() => {
        if (cities) {
            fillCitiesOptions(cities);
        }
    }, [cities])

    async function getRoadmapsAndFillOptionsInput() {
        try {
            const options = adapterOptions(formRoadmaps);
            setRoadmapsInputOptions([{ label: 'Показать все маршруты', value: '11' }, ...options]);
        }
        catch (err) {

        }
    }

    function fillBusStationsInputOptions(array: IBusStation[] | IStopPointShipping[], type: 'FROM' | 'TO' = 'FROM') {

        const options = array.map((el) => ({
            // label: el.stop_name,
            //value: el.stop_id.toString(),
            label: el.area_name,
            value: el.area_id.toString(),
        }));
        if (type === 'FROM') {
            setBusStationsInputOptions(options);
        } else {
            setBusStationsToInputOptions(options);
        }
    }

    // Наполнить инпут населенных пунктов, в которые можно уехать из текущего населенного пункта (отфильтровать)
    useEffect(() => {
        if (citiesTo) {
           fillCitiesToOptions(citiesTo);
        }
    }, [citiesTo])

    useEffect(() => {
        if (formRoadmaps) {
            getRoadmapsAndFillOptionsInput();
        }
    }, [formRoadmaps])

    // useEffect(() => {
    //     // if (roadmaps?.length < 1 && busStationsTo) {
    //     //     const options = adapterOptions(busStationsTo);
    //     //     setBusStationsToInputOptions(options);
    //     // }
    //     if (roadmaps && busStationsTo) {
    //         let staitions = [];
    //         roadmaps?.forEach((roadmap) => {
    //             roadmap.roadmapPoints?.forEach((p) => {
    //                 if (p.is_stop === 1) {
    //                     staitions.push(p.id.toString())
    //                 }
    //             })
    //         })
    //         const filtred = busStationsTo.filter((bs) => staitions.includes(bs.id.split('_')[0]))

    //         const options = adapterOptions(filtred);
    //         setBusStationsToInputOptions(options);
    //     }
    // }, [roadmaps, busStationsTo])

    // наполнить опции инпута остановок откуда в зависимости от остановок в сторе
    useEffect(() => {
        if (busStationsShippingFrom) {
            fillBusStationsInputOptions(busStationsShippingFrom);
        }
        if (busStationsShippingTo) {

            fillBusStationsInputOptions(busStationsShippingTo, 'TO');
        }
    }, [busStationsShippingFrom, busStationsShippingTo]) // busStationsShippingFrom - остановки полученные по методу SHIPPING, приходят не в полном виде и требуют дальнейшей доработки на фронте

    // useEffect(() => {
    //     if (busStationsTo) {
    //         const options = adapterOptions(busStationsTo);
    //         setBusStationsToInputOptions(options);
    //     }
    // }, [busStationsTo])

    function selectCityForm(param: OptionType) {
        if (param && param.value) {

            const selectedCity = cities.find((c) => c.id.toString() === param.value.toString());
            if (!selectedCity) {
                return
            }
            selectCity(selectedCity);
            selectCityTo(undefined);
        } else {
            selectCity(undefined);
            selectCityTo(undefined);
        }
        dispatch(setRoadmaps([]));
    }

    async function handleSelectCityTo(param: OptionType) {
        try {
            const selectedCity = citiesTo.find((c) => c.id.toString() === param?.value.toString());
            selectCityTo(selectedCity);
        }
        catch (err) {
            console.log(err)
        }
    }



    function selectBusStaitionFromInput(option: IParameter) {
        if (!option) {
            selectBusStaition(null);
            return;
        }
        if (!busStations) return;

        const finded = busStations.find(s => s.area_id.toString() === option.value.toString());
        if (finded) {
            selectBusStaition(finded);
        }
    }

    function handleSelectBusStaitionTo(option: IParameter) {

        console.log('handleSelectBusStaitionTo', option)

        if (!option) {
            selectBusStaitionTo(null);
            return;
        }
        const finded = busStationsTo.find(s => s.area_id.toString() === option.value.toString());
        if (finded) {
            selectBusStaitionTo(finded);
        }
    }

    async function selectRoadmapFromInput(option: IParameter) {
        if (option && option.label) {
            try {
                await selectRoadmapByForm(Number(option.value), option.label.toString());
            } catch (err) {
                console.error(err);
            }
        }
    }

    function selectDate(date: any) {
        dispatch(setRoadmap(undefined));
        dispatch(setRoadmaps([]));
        dispatch(setDate(date))
    }

    useFormResetSync({});

    return (
        <div>
            <Container>
                <ContainerInputs>
                    <SwitchersMapMod isFetchRoadmap={loadings.includes('fetchRoadmaps')} />
                    <div className="map-screen__container-inputs-form">
                        <Text>Откуда:</Text>
                        <InputSelectCity
                            citiesInputOptions={citiesInputOptions}
                            handleSelectCitiy={selectCityForm}
                            isLoadingCities={includesLoadingOption('city', loadings)}
                            isDisabled={includesLoadingOption('city', loadings)}
                        />
                        <InputSelectBusStop
                            options={busStationsInputOptions}
                            //isLoading={isLoadingBusStaitions || isLoadingCities || loadings.includes('fetchBusStationShippingFrom')}
                            isLoading={includesLoadingOption('busStaitions', loadings) || loadings.includes('citiesTo')}
                            handleSelect={selectBusStaitionFromInput}
                            isDisabled={includesLoadingOption('busStaitions', loadings) || loadings.includes('citiesTo')}
                        />
                    </div>
                    <div className="map-screen__container-inputs-form">
                        <Text>Куда:</Text>
                        <InputSelectCity
                            isCityTo={true}
                            citiesInputOptions={citiesToInputOptions}
                            handleSelectCitiy={handleSelectCityTo}
                            isLoadingCities={loadings.includes('citiesTo') || loadings.includes('cities')}
                            isDisabled={loadings.includes('citiesTo') || loadings.includes('cities')}
                        />
                        <InputSelectBusStop
                            isBusStaitionTo={true}
                            options={busStationsToInputOptions}
                            //isLoading={isLoadingBusStaitionsTo}
                            isLoading={includesLoadingOption('busStaitionsTo', loadings)}
                            handleSelect={handleSelectBusStaitionTo}
                            isDisabled={includesLoadingOption('busStaitionsTo', loadings)}
                        />
                    </div>
                    <SwitcherTransport />
                </ContainerInputs>
                {/* <Switchers>
                    <SwitchersMapMod isFetchRoadmap={isFetchRoadmap || isLoadingRoadmaps} />
                    <SwitcherTransport isFetchRoadmap={isFetchRoadmap || isLoadingRoadmaps} />
                </Switchers> */}
            </Container>

            {mode === 'roadMaps' &&
                <ContainerRouteAndDate>
                    <ContainerInputsRAD>
                        <div className="map-screen__container-inputs-form">
                            <Text>Маршрут:</Text>
                            <InputSelectRoadmap
                                isLoadingRoadmaps={loadings.includes('fetchRoadmaps')}
                                options={roadmapsInputOptions}
                                onChange={selectRoadmapFromInput}
                                isDisabled={loadings.includes('fetchRoadmaps')}
                            />
                        </div>
                        <ContainerDateAndRouteSwitcher>
                            <DatePicker onDateChange={selectDate} />
                            <ContainerSwitcherDirectionRoute>
                                <ImageRouteSwitcher
                                    src={checkRoadmapTypes(roadmaps) ? routeSwitcherImageFrom['АВТОБУС'] : routeSwitcherImageFrom['ТРАМВАЙ']}
                                    onClick={() => dispatch(setRouteDirection('from'))}
                                    isActive={routeDirection.includes('from')}
                                />
                                <ImageRouteSwitcher
                                    src={checkRoadmapTypes(roadmaps) ? routeSwitcherImagetTo['АВТОБУС'] : routeSwitcherImagetTo['ТРАМВАЙ']}
                                    onClick={() => dispatch(setRouteDirection('to'))}
                                    isActive={routeDirection.includes('to')}
                                />
                            </ContainerSwitcherDirectionRoute>
                        </ContainerDateAndRouteSwitcher>
                    </ContainerInputsRAD>
                </ContainerRouteAndDate>}
        </div>
    )
}

export default SelectForm;


function checkRoadmapTypes(roadmaps: IRoadmapWithPoints[]) {
    if (roadmaps.length === 0) {
        return true;
    }

    if (roadmaps.some((roadmap) => {
        return !roadmap.veh_type;
    })) {
        return true;
    }

    const isBus = roadmaps.some((roadmap) => {
        return roadmap.veh_type === 'АВТОБУС';
    });
    return isBus;
}


const routeSwitcherImageFrom = {
    ТРАМВАЙ: imgTramRowUp,
    АВТОБУС: imgBusRowUp,
}

const routeSwitcherImagetTo = {
    ТРАМВАЙ: imgTramArrowDown,
    АВТОБУС: imgBusArrowDown,
}

const Container = styled.div`
position: absolute;
display: flex;
left: 30px;
top: 30px;
flex-direction: row;
align-items: center;
justify-content: space-between;
z-index: 1;
transition: right 0.5s;
`

const ContainerRouteAndDate = styled.div`
position: absolute;
left: 755px;
top: 30px;
flex-direction: column;
align-items: center;
justify-content: center;
z-index: 1;
transition: right 0.5s;
`

const ContainerInputsRAD = styled.div`
    display: flex;
    gap: 6px;
    height: 118px;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    padding: 12px 12px;
    z-index: 1;
    background-color: white;
    border-radius: 14px 14px 14px 14px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.5);
    transition: right 0.5s;
`

const ContainerInputs = styled.div`
    display: flex;
    gap: 16px;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 12px 12px;
    z-index: 1;
    background-color: white;
    border-radius: 14px 14px 14px 14px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.5);
    transition: right 0.5s;
`

const ContainerSwitcher = styled.div`
display: absolute;
`

const Switchers = styled.div`
display: flex;
flex-direction: row;
justify-content: space-between;
`

const RowContainer = styled.div`
display: flex;
    gap: 12px;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 7px 12px;
    z-index: 1;
    background-color: white;
    border-radius: 14px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.5);
    transition: right 0.5s;
`

const Text = styled.span`
font-size: 14px;
font-weight: 700;
margin-right: 0px;
width: 39px;
padding:0;
text-align: left;
height: 20px;
`;

const ContainerDateAndRouteSwitcher = styled.div`
    display: flex;
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
`

const ContainerSwitcherDirectionRoute = styled.div`
    display: flex;
    flex-direction: row;
`

const ButtonRouteSwitcher = styled.button`
    
`
interface ImageRouteSwitcherProps {
    isActive: boolean;
}
const ImageRouteSwitcher = styled.img<ImageRouteSwitcherProps>`
  width: 25px;
  height: 25px;
  opacity: ${({ isActive }) => (isActive ? 1 : 0.3)};
  transition: opacity 0.3s ease; 
  cursor: pointer;
`;